import { render, staticRenderFns } from "./CheckBoxFailed.vue?vue&type=template&id=44fd380c&scoped=true&"
import script from "./CheckBoxFailed.vue?vue&type=script&lang=js&"
export * from "./CheckBoxFailed.vue?vue&type=script&lang=js&"
import style0 from "./CheckBoxFailed.vue?vue&type=style&index=0&id=44fd380c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd380c",
  null
  
)

export default component.exports